import React from 'react';
import { useParams } from 'react-router-dom';
import ConnectionsMobileSubnav from './ConnectionsMobileSubnav';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import ProgressiveProfilingForm from '../../../modals/ProgressiveProfilingModal/ProgressiveProfilingForm';
import StepOne from '../../../modals/ProgressiveProfilingModal/StepOne';
import StepTwo from '../../../modals/ProgressiveProfilingModal/StepTwo';
import MatchCriteriaTitleBase from './CreateMatchesForm/MatchCriteriaTitle';
import SectionHeader from '../../../_molecules/SectionHeader';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';

import useDocumentTitle from '@hooks/useDocumentTitle';

const MatchCriteriaTitle = props => <MatchCriteriaTitleBase submitButtonClass="editcriteria" {...props} />;

export const UpdateMatchCriteriaPage = () => {
    const { id } = useParams();
    useDocumentTitle('Edit Match Criteria');

    return (
        <ErrorHandler>
            <TrackPageView>
                <ConnectionsMobileSubnav />

                <div className="p-4 fade-in-fast">
                    <SectionHeader title="My ICSC Connections" />
                    <SectionBreadcrumbs className="mt-2">
                        <SectionBreadcrumb route="/my-icsc/connections">Connections</SectionBreadcrumb>
                        <SectionBreadcrumb route="/my-icsc/connections/matches">My Matches</SectionBreadcrumb>
                        <SectionBreadcrumb isActive>Edit Match Criteria</SectionBreadcrumb>
                    </SectionBreadcrumbs>

                    <h1 className="mt-2 mb-3">Edit Match Criteria</h1>

                    <div className="mt-4 p-4" style={{ boxShadow: '0 0 15px rgb(0 0 0 / 30%)' }}>
                        <ProgressiveProfilingForm steps={[StepOne, StepTwo, MatchCriteriaTitle]} id={id} />
                    </div>
                </div>
            </TrackPageView>
        </ErrorHandler>
    );
};
